import { useParams } from "react-router-dom";
import { LAWYERS } from "src/constants/lawyers";
import { useScrollSpy } from "./hooks/useScrollSpy";
import { LawyerBanner, LawyerTabBar, LawyerDescription } from "./components";
import { Footer } from "src/v1/ui/footer/Footer";
import NotFoundPage from "src/v1/features/NotFound/NotFoundPage";

export default function LawyerDetailPage() {
  const { slug } = useParams();
  const lawyer = LAWYERS.find((l) => l.slug === slug);
  const { activeId, observeRef } = useScrollSpy("introduction");

  if (!lawyer) return <NotFoundPage />;

  const handleTabClick = (sectionId: string) => {
    if (sectionId === "introduction") {
      window.scrollTo({ top: 48, behavior: "smooth" });
    } else {
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main>
      <LawyerBanner lawyer={lawyer} />
      <div className="desktop:flex desktop:max-w-[1150px] desktop:mx-auto desktop:gap-12 desktop:mt-12">
        <LawyerTabBar activeTab={activeId} onTabClick={handleTabClick} />
        <div className="desktop:flex-1 desktop:min-w-0 mt-6 desktop:mt-0">
          <LawyerDescription
            observeRef={observeRef}
            introduction={lawyer.introduction}
            careerDetails={lawyer.careerDetails}
            education={lawyer.education}
            qualifications={lawyer.qualifications}
            performance={lawyer.performance}
          />
        </div>
      </div>
      <Footer />
    </main>
  );
}
